/* ActiveDockletsRenderer.js */

"use strict";

class ActiveDockletsRenderer {
    /**
     * Constructor
     * @param {Object} model
     */
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("active-docklets");
        this._rootElem.component = this._model;
        this._options = document.createElement("options");
        this._gearIcon = document.createElement("config");
        this._options.appendChild(this._gearIcon);
        this._rootElem.appendChild(this._options);
        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */

    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve) => {
            this._unregisterListeners();
            this._removeAllIcons();
            this._rootElem.component = null;
            this._rootElem.remove();
            this._rootElem = null;
            this._options = null;
            this._gearIcon = null;
            this._model = null;
            resolve();
        });
        return prom;
    }

    _registerListeners() {
        this._dockletIconClickHandler = this._dockletIconClickHandler.bind(this);
        this._gearIconClickHandler = this._gearIconClickHandler.bind(this);
        this._gearIcon.addEventListener("click", this._gearIconClickHandler);
        this._model.on("Shutdown", () => this._shutdown());
    }

    _unregisterListeners() {
        this._gearIcon.removeEventListener("click", this._gearIconClickHandler);
    }

    /**
     * Add an enabled icon to the part menu list
     * @param part
     */
    _addDocklet(part) {
        let iconEl = document.createElement("part");
        iconEl.setAttribute("data-id", part.id);
        iconEl.classList.add("bar");

        let svg = document.createElement("lmrb-icon-gl");
        svg.dataset.icon = part.iconRepoName;

        iconEl.appendChild(svg);
        svg.setAttribute("data-id", part.name);
        svg.setAttribute("data-lmrb-side", this._model._state._name);

        iconEl.setAttribute("title", part.displayName);
        iconEl.addEventListener("click", () => {
            this._dockletIconClickHandler(part.id);
        });
        this.rootElement.appendChild(iconEl);
    }

    _removePartNode(node) {
        //node.removeEventListener("click", this._dockletIconClickHandler);
        this.rootElement.removeChild(node);
    }

    _getDocklet(id) {
        return this.rootElement.querySelector('part[data-id="' + id + '"]');
    }

    _getAllDocklets() {
        return this.rootElement.querySelectorAll("part");
    }

    /**
     * Handles click events for the config option icon
     */
    _gearIconClickHandler() {
        this._model.gearIconClicked();
    }

    /**
     * Handles click events for the enabled part icons
     * @param evt
     */
    _dockletIconClickHandler(id) {
        this._model.dockletClicked(id);
    }

    _removeAllIcons() {
        for (let icon of this._getAllDocklets()) {
            this._removePartNode(icon);
        }
    }

    _setOptionsTitle() {
        if (this._model._state.optionsOpened) {
            this._gearIcon.setAttribute("title", "Close Options");
        } else {
            this._gearIcon.setAttribute("title", "Open Options");
        }
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     */
    render() {
        let allIcons = this._getAllDocklets();
        if (allIcons && allIcons.length > 0) {
            this._removeAllIcons();
        }
        this._model.getPartIds().forEach((id) => {
            this._addDocklet(this._model.getPart(id));
        });
        this._setOptionsTitle();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/
    //TODO - Nobody should be using methods on a Renderer directly so make all these methods private
    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = ActiveDockletsRenderer;
